import { handleEnquiry } from './enquiries';

export const showContactOptionsModal = (
	$button,
	sellerProfileId,
	projectId,
	buyerUserId,
	companyName,
	contactOptions,
	trackingData,
	marketplaceInteractionCompleteCallback,
	isLastSellerToInteractOnMarketplaceList,
) => {
	try {
		if (window.BuyerCallbacks) {
			window.BuyerCallbacks.launchModule(
				'callbacks-contact-options-modal',
				'__rctSellerListContactOptions',
				{
					sellerProfileId,
					projectId,
					buyerUserId,
					companyName,
					contactOptions,
					trackingData,
					showMessageSentConfirmation: !isLastSellerToInteractOnMarketplaceList,
					onClickCall: () =>
						handleEnquiry(
							$button,
							trackingData,
							marketplaceInteractionCompleteCallback,
							isLastSellerToInteractOnMarketplaceList,
						),
					onMessageSendComplete: () =>
						marketplaceInteractionCompleteCallback?.(
							'marketplace-messages',
							sellerProfileId,
						),
				},
			);
		}
	} catch (error) {
		console.log(error);
	}
};

export const showSendMessageModal = (
	sellerProfileId,
	projectId,
	buyerUserId,
	companyName,
	trackingData,
	marketplaceInteractionCompleteCallback,
	isLastSellerToInteractOnMarketplaceList,
) => {
	try {
		if (window.BuyerCallbacks) {
			window.BuyerCallbacks.launchModule(
				'callbacks-send-message-modal',
				'__rctSellerListSendMessage',
				{
					sellerProfileId,
					projectId,
					buyerUserId,
					companyName,
					trackingData,
					showMessageSentConfirmation: !isLastSellerToInteractOnMarketplaceList,
					onComplete: () =>
						marketplaceInteractionCompleteCallback?.(
							'marketplace-messages',
							sellerProfileId,
						),
				},
			);
		}
	} catch (error) {
		console.log(error);
	}
};
